import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberNotificationSettingsKey, getPostsKey, getSpaceKey, } from '../../utils/keys';
export const useJoinSpace = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.spaces.join(input), {
        onSettled: (data, error, variables) => {
            queryClient.invalidateQueries(getSpaceKey({ id: variables.spaceId }));
            queryClient.invalidateQueries(getMemberNotificationSettingsKey());
            queryClient.invalidateQueries(getPostsKey());
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useJoinSpace.js.map